<script>
import debounce from 'lodash/debounce';
import Multiselect from 'vue-multiselect';
import ContactModel from '@models/Contact';

export default {
  components: {
    Multiselect,
  },
  props: {
    // eslint-disable-next-line
    value: {
      required: true,
    },
    initialValue: {
      default: null,
      type: Object,
    },
    placeholder: {
      default: 'Type to search',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    state: {
      default: false,
      type: Boolean,
    },
    sort: {
      type: String,
      default: 'name',
    },
    company: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      entities: [],
      isLoading: false,
      selectedEntity: this.initialValue,
      focused: false,
      minChars: 2,
    };
  },
  watch: {
    selectedEntity(val) {
      const id = val ? val.id : null;
      this.$emit('input', id);
      this.$emit('change', id);
    },
    initialValue() {
      this.selectedEntity = { id: this.initialValue.id, name: `${this.initialValue.first_name} ${this.initialValue.last_name}` };
    },
  },
  methods: {
    getProvider: debounce(function(query) {
      if (query.length >= 3) {
        this.isLoading = true;
        this.asyncEntities(query);
      }
    }, 300),
    asyncEntities: debounce(function(query) {
      if (query.length >= this.minChars) {
        this.isLoading = true;
        let tempData = [];
        ContactModel.where('name', query)
          .where('company_id', this.company)
          .orderBy(`-${this.sort}`)
          .page(1)
          .limit(30)
          .get()
          .then((response) => {
            response.data.forEach((data) => {
              tempData.push({ id: data.id, name: `${data.first_name} ${data.last_name}` });
            });
            this.entities = tempData;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    }, 300),
  },
};
</script>

<template>
  <div class="multiselect-container kks-multiselect-container" :class="{ 'is-invalid': state, focused: focused }">
    <Multiselect
      ref="multiselect"
      v-model="selectedEntity"
      label="name"
      track-by="id"
      :placeholder="placeholder"
      open-direction="bottom"
      :options="entities"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :options-limit="10"
      :max-height="600"
      :disabled="disabled"
      :show-no-results="true"
      @open="focused = true"
      @close="focused = false"
      @search-change="getProvider"
    >
      <div slot="noResult" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
      <div slot="noOptions" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
    </Multiselect>
  </div>
</template>
